import * as React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { confirmPopup } from 'primereact/confirmpopup';
import { parseISO, format } from 'date-fns';
import { useAxios } from '../../utils/hooks.ts';

// Self-service list/revoke for MCP OAuth connections (grants created via the /authorize
// consent screen) - the OAuth equivalent of ApiKeys.js for static keys.
export default function ConnectedApps({ displayToast }) {
    const [ grants, setGrants ] = React.useState([]);
    const [ fetchFlag, setFetchFlag ] = React.useState(false);
    const axiosInstance = useAxios();

    const flipFetchFlag = () => {
        setFetchFlag(!fetchFlag);
    }

    React.useEffect(() => {
        axiosInstance.current.get("/oauth/grants").then((response) => {
            setGrants(response.data);
        })
        .catch((err) => {
            console.log(err);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchFlag]);

    const revoke = (grant) => {
        axiosInstance.current.delete("/oauth/grants/" + grant.grantId).then(() => {
            flipFetchFlag();
        })
        .catch((err) => {
            console.log(err);
            displayToast({ severity: 'error', summary: 'Error!', detail: 'Unable to revoke connection' });
        })
    }

    const confirmRevoke = (grant, e) => {
        confirmPopup({
            target: e.currentTarget,
            message: "Are you sure you want to revoke this connection? It will stop working immediately.",
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: () => revoke(grant),
            reject: () => {}
        })
    }

    const statusBody = (rowData) => <Tag severity={rowData.revoked ? 'danger' : 'success'} value={rowData.revoked ? 'Revoked' : 'Active'} />;
    const createdBody = (rowData) => rowData.createdAt ? format(parseISO(rowData.createdAt), "MMMM dd, yyyy h:mm a") : '';
    const lastUsedBody = (rowData) => rowData.lastUsedAt ? format(parseISO(rowData.lastUsedAt), "MMMM dd, yyyy h:mm a") : 'Never';
    const actionsBody = (rowData) => (
        !rowData.revoked && <Button className="p-button-outlined p-button-danger" icon="pi pi-ban" onClick={(e) => confirmRevoke(rowData, e)} />
    );

    return (
        <div className="mt10">
            <div className="secondary-title mt10">
                Connected Apps
            </div>
            <DataTable value={grants} responsiveLayout="stack" size="small" dataKey="grantId" emptyMessage="No connected apps yet">
                <Column field="clientId" header="App"></Column>
                <Column field="projectName" header="Project"></Column>
                <Column field="role" header="Access Level"></Column>
                <Column body={statusBody} header="Status"></Column>
                <Column body={createdBody} header="Connected"></Column>
                <Column body={lastUsedBody} header="Last Used"></Column>
                <Column body={actionsBody}></Column>
            </DataTable>
        </div>
    )
}
